import React from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import Avatar from '../components/Avatar';
import { Link, useNavigate } from "react-router-dom";

function Scores_partie(props) {
    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom="David"
                    mail="david.st@word.in"
                    worder="WOrder : 30"
                    src="/img/players/player_d.png"
                    classes="w-avatar-info"
                />
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn-white" />
                </Link>
                <Link to="/scorespartie">
                    <Button text="Voir les scores" classes="w-btn-white" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn-white" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>

            <div className='col-lg-9 w-half-right-full'>

                <Text text="En ligne : 250" classes="mt-4 mb-4 text-center w-text-blue-l w-text-green-bold" />

                <Text text="Communauté WordIn : 3250" classes="mt-4 mb-4 text-center w-text-gray-l" />

                <Text text="Classement:" classes="mt-4 mb-4 text-center w-text-blue-title" />

                <div className='row mt-5'>

                    <div className="col-lg-3">
                    <Avatar
                            type="w-avatar-lg"
                            nom="David"
                            worder="1"
                            text="53200pts"
                            src="/img/players/player_d.png"
                            classes="w-avatar-lg bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                                type="w-avatar-lg"
                                nom="David"
                                worder="1"
                                text="53200pts"
                                src="/img/players/player_d.png"
                                classes="w-avatar-lg bg-blue-semi-lte"
                            />
                    </div>

                    <div className="col-lg-3">
                        <Avatar
                                type="w-avatar-lg"
                                nom="David"
                                worder="1"
                                text="53200pts"
                                src="/img/players/player_d.png"
                                classes="w-avatar-lg bg-blue-semi-lte"
                            />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                                type="w-avatar-lg"
                                nom="David"
                                worder="1"
                                text="53200pts"
                                src="/img/players/player_d.png"
                                classes="w-avatar-lg bg-blue-semi-lte"
                            />
                    </div>
                    
                     

                </div>
         </div>
        </div>
    );
}

export default Scores_partie;